import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import http from "./utils/http";
import VueBus from 'vue-bus';


Vue.config.productionTip = false

Vue.prototype.$http = http;
Vue.use(ElementUI);
Vue.use(VueBus);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
